module.exports = __webpack_public_path__ + "static/media/mindtree-logo.c5874baf.png";